import React, { FC } from 'react';
import moment from 'moment';
import { useTranslations } from '@lang';
import { ResetButton } from './ResetDate.styles';

type ResetDateProps = {
  handleResetDate: ({
    startDate,
    endDate,
  }: {
    startDate: moment.Moment;
    endDate: moment.Moment;
  }) => void;
};

export const ResetDate: FC<ResetDateProps> = ({ handleResetDate }) => {
  const { t } = useTranslations();
  return (
    <ResetButton
      onClick={() => handleResetDate({ startDate: moment(), endDate: moment().add(1, 'days') })}
    >
      {t('common.resetDate')}
    </ResetButton>
  );
};
